
export const userColumns =[

  
    {
      name: 'username',
      selector: row => row.username,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'phone',
      selector: row => row.phone,
      sortable: true,
    },
  
   
    
]










 
  

 